export default __webpack_public_path__ + "static/media/experts0.60d67635.jpg";